import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { setIsLoading, setWorkInLocationList, } from "../slices/reportSlice";
import * as services from "../services/reportApi";
import { generateRandomString } from "utils/helper";
import * as slices from "../slices/reportSlice"
import * as employeeServices from "features/employee/services/employeeApi";
import { setReportTableWorkingTime } from "../slices/reportSlice";
import { getEmployeeStatusTypeOptions, getEmploymentTypeOptions } from "features/masterData/services/optionsApi";
import useOptions from "features/masterData/hooks/useOptions";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

function useWorkingExpense() {
    const [showReport, setShowReport] = useState(false);
    const { t, i18n } = useTranslation();
    const { currentEmployee } = useSelector((state) => state.company)
    const currentEmployeeId = useSelector((state) => state.company.currentEmployee);
    const dispatch = useDispatch();
    const [lang, setLang] = useState("en");
    const { employeeStatusTypeOptions, getEmployeeStstuaTypeOptions } = useOptions();
    const reportTableWoringTime = useSelector((state) => state.report.reportExpenseRequestCompany || []);
    const [positionOptions, setPositionOptions] = useState([]);
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [departmentListOption, setDepartmentListOption] = useState([]);
    const [workInLocationList, setWorkInLocationList] = useState([]);
    const currentCompany = useSelector((state) => state.company.currentCompany);
    const [pagination, setPagination] = useState({ page: 0, currentPage: 0, size: 10 });
    const [pagination2, setPagination2] = useState({ page: 0, currentPage: 0, size: 10 });
    const [search, setSearch] = useState({});
    const [isDownloading, setIsDownloading] = useState(false);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };

    function ddlDate() {
        // เดือนปัจจุบัน, เดือนก่อน, 3เดือน, 6 เดือน, 1 ปี, ปีก่อน
        //  label: i18n.language === "en" ? opt.nameEn : opt.name,
        //   value: opt.id,
        // 
        let list = []
        list.push({
            label: "เดือนปัจจุบัน",
            value: '1',
            option: [dayjs().startOf('month'), dayjs().endOf('month')]
        })
        list.push({
            label: "เดือนก่อน",
            value: '2',
            option: [dayjs().add(-1, 'month').startOf('month'), dayjs().add(-1, 'month').endOf('month')]
        })
        list.push({
            label: "2 เดือน",
            value: '3',
            option: [dayjs().add(-2, 'month'), dayjs()]
        })
        list.push({
            label: "3 เดือน",
            value: '4',
            option: [dayjs().add(-3, 'month'), dayjs()]
        })
        list.push({
            label: "6 เดือน",
            value: '5',
            option: [dayjs().add(-6, 'month'), dayjs()]
        })
        list.push({
            label: "1 ปี",
            value: '6',
            option: [dayjs().add(-6, 'month'), dayjs()]
        })
        list.push({
            label: "ปีปัจจุบัน",
            value: '7',
            option: [dayjs().startOf('year'), dayjs()]
        })
        list.push({
            label: "ปีก่อน",
            value: '8',
            option: [dayjs().add(-1, 'year').startOf('year'), dayjs()]
        })
        return list;
    }

    function toParams(params = {}) {
        const { pagination = {}, sortBy = [] } = params;
        const modifiedParams = {
            pagination: {
                page: pagination?.page,
                size: pagination?.pageSize,
            },
            sortBy: sortBy
                .filter((s) => s.order !== undefined)
                .map((s) => ({
                    direction: s.order === "descend" ? "desc" : "asc",
                    property: s.field,
                })),
        };
        return modifiedParams;
    }

    const getSearchAbsenceReport = useCallback(
        async (params = {}) => {
            try {
                dispatch(setIsLoading(true));
                console.log("parrrrrm", params);

                const response = await services.getMyExpenseRequestCompanyPagination({
                    ...params,
                    companyId: currentCompany,
                    employeeId: currentEmployee,
                    ...params.pagination,
                });
                console.log("Response data jaaa", response?.data?.page?.content);

                const employeeNos = response?.data?.page?.content?.map((item) => item?.employeeInfo?.employeeNo);
                console.log("Employee Nos:", employeeNos);

                dispatch(slices.setReportExpenseRequestCompany(response?.data?.page?.content));
                setPagination({
                    ...pagination,
                    // ...params?.request,
                    current: response?.data?.page?.pageable?.pageNumber + 1,
                    pageNo: response?.data?.page?.pageable?.pageNumber + 1,
                    size: response?.data?.page?.pageable?.pageSize,
                    total: response.data?.page?.totalElements,
                });
                return employeeNos;
            } catch (error) {
                console.error("Error fetching report history:", error);
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [dispatch, reportTableWoringTime, currentEmployee, pagination]
    );
    const getReportTableWorkingTimeCustomer = useCallback(
        async (params = {}) => {
            try {
                dispatch(setIsLoading(true));
                console.log("parrrrrm", params);

                const response = await services.getReportTableWorkingTimeCustomer({
                    ...params,
                    companyId: currentCompany,
                    employeeId: currentEmployee,
                    ...params.pagination,
                });
                console.log("Response data jaaa", response?.data?.page?.content);

                const employeeNos = response?.data?.page?.content?.map((item) => item?.employeeInfo?.employeeNo);
                console.log("Employee Nos:", employeeNos);

                dispatch(slices.setReportTableWorkingTime2(response?.data?.page?.content));
                setPagination2({
                    ...pagination2,
                    // ...params?.request,
                    current: response?.data?.page?.pageable?.pageNumber + 1,
                    pageNo: response?.data?.page?.pageable?.pageNumber + 1,
                    size: response?.data?.page?.pageable?.pageSize,
                    total: response.data?.page?.totalElements,
                });
                return employeeNos;
            } catch (error) {
                console.error("Error fetching report history:", error);
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [dispatch, reportTableWoringTime, currentEmployee, pagination2]
    );


    const getPosition = useCallback(async () => {
        if (typeof currentCompany !== "object") {
            try {
                dispatch(setIsLoading(true));
                const values = {
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    employeeId: currentEmployeeId
                };
                const response = await services.getPositionDropdownList(values);
                setPositionOptions(response?.data?.content || []);
            } catch (error) {
                // alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        }
    }, [currentCompany, currentEmployeeId, dispatch]);

    const getWorkInLocation = useCallback(async () => {
        try {
            // dispatch(setIsLoading(true))
            const response = await services.getWorkInLocation({
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee
            })
            dispatch(setWorkInLocationList(response?.data))
            // Alert({ message: 'success', type: 'success' })
        } catch (error) {
            // alert({ type: 'error', resultObject: error })
        } finally {
            // dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, dispatch])

    const modifiedEmployeeOptions = useMemo(() => {
        return employeeOptions.map((opt) => ({
            ...opt,
            label: lang === "en" ? opt.fullNameEn : opt.fullName,
            value: opt.id,
        }));
    }, [lang, employeeOptions]);

    const getEmployeeOptions = useCallback(async () => {
        if (typeof currentCompany !== "object") {
            try {
                dispatch(setIsLoading(true));
                const values = {
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                };
                const response = await employeeServices.getDropDown(values);
                setEmployeeOptions(response.data);
            } catch (error) {
                alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        }
    }, [currentCompany, dispatch]);





    const modifiedWorkInLocationList = useMemo(() => {
        const modifiedOptions = workInLocationList?.map((workInLocation) => {
            return {
                label: workInLocation?.name,
                value: workInLocation?.id
            }
        })
        return modifiedOptions?.sort((a, b) =>
            a?.label?.localeCompare(b?.label, i18n?.language === "en" ? "en" : "th", { sensitivity: "base" }));
    }, [i18n.language, workInLocationList])

    const modifiedPositionOptions = useMemo(() => {
        const modifiedOptions = positionOptions.map((opt) => ({
            ...opt,
            id: opt?.positionId,
            value: opt?.positionId,
            nameEn: opt?.positionNameEn,
            name: opt?.positionName,
            label: i18n.language === "en" ? opt?.positionNameEn : opt?.positionName,
        }));
        return modifiedOptions?.sort((a, b) =>
            a?.label?.localeCompare(b?.label, i18n?.language === "en" ? "en" : "th", { sensitivity: "base" }));
    }, [i18n.language, positionOptions]);

    const modifiedDepartmentOption = useMemo(() => {
        const modifiedOptions = departmentListOption?.map((opt) => ({
            ...opt,
            value: opt?.id,
            label: i18n.language === "en" ? opt?.nameEn : opt?.name,
        }));

        return modifiedOptions?.sort((a, b) =>
            a?.label?.localeCompare(b?.label, i18n?.language === "en" ? "en" : "th", { sensitivity: "base" }));;
    }, [i18n.language, departmentListOption]);



    const onChange = useCallback(
        (tablePagination, tableFilters, tableSorter, tableExtra) => {
            console.log('table', tablePagination);

            const modifiedSorter = Array.isArray(tableSorter)
                ? [...tableSorter]
                : [tableSorter];
            const modifiedParams = toParams({
                pagination: {
                    page: tablePagination.current - 1,
                    pageSize: tablePagination.pageSize,
                    current: tablePagination.current - 1,
                },
                sortBy: modifiedSorter,
            });
            setPagination({ ...pagination, ...modifiedParams?.pagination })
            getSearchAbsenceReport({ ...modifiedParams, request: pagination.request, ...search });
        },
        [getSearchAbsenceReport, pagination]
    );

    const onChange2 = useCallback(
        (tablePagination, tableFilters, tableSorter, tableExtra) => {
            console.log('table', tablePagination);

            const modifiedSorter = Array.isArray(tableSorter)
                ? [...tableSorter]
                : [tableSorter];
            const modifiedParams = toParams({
                pagination: {
                    page: tablePagination.current - 1,
                    pageSize: tablePagination.pageSize,
                    current: tablePagination.current - 1,
                },
                sortBy: modifiedSorter,
            });
            setPagination2({ ...pagination2, ...modifiedParams?.pagination })
            getReportTableWorkingTimeCustomer({ ...modifiedParams, request: pagination2.request, ...search });
        },
        [getReportTableWorkingTimeCustomer, pagination2]
    );


    const getDepartment = useCallback(async () => {
        if (!currentCompany) return null;
        try {
            dispatch(setIsLoading(true));
            const response = await services.getDropdownDepartmentByRoleHr({
                requestId: generateRandomString(),
                companyId: currentCompany,
                employeeId: currentEmployeeId
            });
            dispatch(setDepartmentListOption(response?.data?.content || []));
        } catch (error) {
            // alert({ type: "error", resultObject: error });
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [currentCompany, currentEmployeeId, dispatch]);


    const exportWorkingTimeGroupReport = useCallback(
        async (record) => {
            try {
                // console.log("onDownload");
                dispatch(setIsLoading(true));
                const res = await services.ExportExpenseSummary({
                    companyId: currentCompany,
                    ...search,
                    ...pagination,
                    isReport: "Y",
                    employeeId: record?.employeeInfo?.id
                });
                // console.log("res ", res);

                if (res && res.data) {
                    const url = window.URL.createObjectURL(res.data);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `benefit_all_${dayjs().format("YYYYMMDD")}.xlsx`);

                    document.body.appendChild(link);
                    link.click();
                    link.remove();

                    window.URL.revokeObjectURL(url);
                } else {
                    console.error("No data received for the download.");
                }
            } catch (error) {
                console.error("Error fetching report history:", error);
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, pagination, search, dispatch]
    );

    const exportWorkingTimeGroupReportAll = useCallback(
        async (params = {}) => {
            try {
                console.log("params", params);

                setIsDownloading(true);
                dispatch(setIsLoading(true));
                services.ExportExpense({
                    // reportName: "TIME_STAMP_REPORT",
                    ...params,
                    companyId: currentCompany,
                    employeeId: currentEmployee,
                    ...params.pagination,
                    ...search,
                    ...pagination,
                    isReport: "Y"
                }).then(res => {
                    console.log("res", res.data);
                    const url = window.URL.createObjectURL(res.data);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `benefit_${dayjs().format("YYYYMMDD")}.` + params.reportType);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                });
            } catch (error) {
                console.error("Error fetching report history:", error);
            } finally {
                dispatch(setIsLoading(false));
                setIsDownloading(false);
            }
        },
        [currentCompany, pagination, search, dispatch]
    );
    const exportExpenseSummary = useCallback(
        async (params = {}) => {
            try {
                setIsDownloading(true);
                dispatch(setIsLoading(true));
                services.ExportExpenseSummary({
                    // reportName: "TIME_STAMP_REPORT",
                    employeeId: currentEmployee,
                    ...params,
                    companyId: currentCompany,
                    employeeId: currentEmployee,
                    ...params.pagination,
                    ...search,
                    ...pagination,
                    isReport: "Y"
                }).then(res => {
                    console.log("res", res.data);
                    const url = window.URL.createObjectURL(res.data);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `benefit_${dayjs().format("YYYYMMDD")}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                });
            } catch (error) {
                console.error("Error fetching report history:", error);
            } finally {
                dispatch(setIsLoading(false));
                setIsDownloading(false);
            }
        },
        [currentCompany, pagination, search, dispatch]
    );

    const downloadBytes = (bytes, filename, mimeType = "application/octet-stream") => {
        const byteCharacters = atob(bytes); // Decode Base64 to binary string
        const byteNumbers = Array.from(byteCharacters).map(char => char.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);

        const blob = new Blob([byteArray], { type: mimeType });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();

        URL.revokeObjectURL(url); // Clean up
    };


    const handleSearch = (values) => {
        setShowReport(true)
        setSearch({})
        console.log("handleSearch", values);
        let searchTxt = (values.employeeNo ?? "") + (values.employeeFullName ?? "")
        try {

            let startDate = null
            let endDate = null
            if (values?.workingTimeDatePicker) {
                startDate = values?.workingTimeDatePicker?.[0]?.format('YYYY-MM-DD')
                endDate = values?.workingTimeDatePicker?.[1]?.format('YYYY-MM-DD')
            } else {
                startDate = ddlDate().find(o => o.value == values?.workingTimeDate)?.option?.[0] ? ddlDate().find(o => o.value == values?.workingTimeDate)?.option?.[0]?.format('YYYY-MM-DD') : null
                endDate = ddlDate().find(o => o.value == values?.workingTimeDate)?.option?.[1] ? ddlDate().find(o => o.value == values?.workingTimeDate)?.option?.[1]?.format('YYYY-MM-DD') : null
            }

            setSearch({
                ...values,
                searchTxt: searchTxt,
                startDate,
                endDate,
            })
            getSearchAbsenceReport({
                ...values,
                searchTxt: searchTxt,
                startDate,
                endDate,
                ...pagination
            })
            // getReportTableWorkingTimeCustomer({
            //     ...values,
            //     startDate: values?.workingTimeDate?.[0] ? values?.workingTimeDate?.[0]?.format('YYYY-MM-DD') : null,
            //     endDate: values?.workingTimeDate?.[1] ? values?.workingTimeDate?.[1]?.format('YYYY-MM-DD') : null,
            //     ...pagination
            // })
        } catch (error) {
            console.log("error", error);

        }

    };
    useEffect(() => {
        setLang(i18n.language);
    }, [i18n.language, setLang]);


    useEffect(() => {
        getDepartment();
        getEmployeeOptions();
        getPosition();
        getWorkInLocation();
        getEmployeeStstuaTypeOptions();
    }, [getDepartment, getPosition, getEmployeeStstuaTypeOptions, getWorkInLocation, getEmployeeOptions])
    return {
        showReport,
        handleSearch,
        employeeOptions: modifiedEmployeeOptions,
        reportTableWoringTime,
        departmentOptions: modifiedDepartmentOption,
        positionOptions: modifiedPositionOptions,
        workInLocationList: modifiedWorkInLocationList,
        getReportTableWorkingTime: getSearchAbsenceReport,
        getReportTableWorkingTimeCustomer,
        getWorkInLocation,
        employeeStatusTypeOptions,
        pagination,
        pagination2,
        onChange,
        onChange2,
        getEmployeeStstuaTypeOptions,
        exportWorkingTimeGroupReport,
        exportWorkingTimeGroupReportAll,
        exportExpenseSummary,
        isModalOpen,
        setIsModalOpen,
        showModal,
        isDownloading,
        ddlDate
    }
}
export default useWorkingExpense;